// extracted by mini-css-extract-plugin
module.exports = {"mobileLeaveMeetingWrapper":"MobileLeaveMeeting_mobileLeaveMeetingWrapper__knpvC","mobileLeaveMeetingButtonHolder":"MobileLeaveMeeting_mobileLeaveMeetingButtonHolder__1nBrb"};